<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="$refs.table.reload()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="订单编号：">
        <el-input v-model="dataForm.orderCode" size="mini" clearable type="text"
                  placeholder="请输入订单编号"></el-input>
      </el-form-item>
      <el-form-item label="销售方：">
        <el-input v-model="dataForm.sellerName" size="mini" clearable type="text"
                  placeholder="请输入销售方"></el-input>
      </el-form-item>
      <el-form-item prop="receiptCode" label="发票号：">
        <el-input v-model="dataForm.receiptCode" size="mini" clearable type="text"
                  placeholder="请输入发票号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="$refs.table.reload()" size="mini">查询</el-button>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" url="/erp/pay/report/order" :before-table-binding="beforeTableBinding" :query-form="dataForm">
      <el-table-column prop="orderCode" label="订单编号" header-align="center"
                       align="center" min-width="160"></el-table-column>
      <el-table-column prop="sellerName" label="销售方" header-align="center"
                       align="center" min-width="160"></el-table-column>
      <el-table-column prop="code" label="发票号" header-align="center"
                       align="center" min-width="160"></el-table-column>
      <el-table-column prop="totalAmount" label="发票金额" header-align="center"
                       align="center" min-width="90"></el-table-column>
      <el-table-column prop="payedAmount" label="已付款" header-align="center"
                       align="center" min-width="90">
      </el-table-column>
      <el-table-column prop="unPayAmount" label="未付款" header-align="center"
                       align="center" min-width="90"></el-table-column>
    </SweetTable>
  </div>
</template>

<script>
import BigNumber from 'bignumber.js'

export default {
  name: 'pay-detail',
  data () {
    return {
      dataForm: {
        sellerName: '',
        receiptCode: '',
        orderCode: '',
      },
    }
  },
  activated () {
    this.$nextTick(() => {
      this.$refs.table.reload()
    })
  },
  methods: {
    beforeTableBinding (dataList) {
      dataList.forEach(item => {
        let totalAmount = new BigNumber(item.totalAmount)
        item.unPayAmount = totalAmount.minus(item.payedAmount || 0).toFixed(3)
      })
    },
  }
}
</script>

<style scoped>

</style>
